import { newTraceparent, shouldPropagateTo, asUrlString } from './browserTracing';
import { reportFrontendError } from './reportFrontendError';
import type { ObservabilityConfig } from './types';

export function createFetchWithErrorSummary(config: ObservabilityConfig) {
  return async function fetchWithErrorSummary(
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> {
    const targetUrl = asUrlString(input);

    let nextInit: RequestInit | undefined = init;
    let traceparent: ReturnType<typeof newTraceparent> | null = null;

    if (shouldPropagateTo(targetUrl, config.propagationTargets)) {
      traceparent = newTraceparent();
      const headers = new Headers(init?.headers);
      headers.set('traceparent', traceparent.header);
      nextInit = { ...(init ?? {}), headers };
    }

    const response = await fetch(input, nextInit);

    if (!response.ok) {
      void reportFrontendError({
        applicationName: config.applicationName,
        eventType: 'api_request_failure',
        message: `API request failed with status ${response.status}`,
        route: window.location.pathname,
        url: window.location.href,
        userAgent: window.navigator.userAgent,
        traceId: traceparent?.traceId,
        spanId: traceparent?.spanId,
        requestSummary: {
          method: nextInit?.method ?? init?.method ?? 'GET',
          target: targetUrl,
          status: response.status,
        },
      });
    }

    return response;
  };
}
